module.exports = __webpack_public_path__ + "img/9.c0150d78.jpg";